module.exports = __webpack_public_path__ + "static/media/revoo-logo.5ec40da3.png";